import { elakayAutoText } from "../pageInside/dataElakay";
import { getCommercialCapabilities, isProviderOnlyWorkspace } from "../pageInside/Rolle";

// One role-aware source for the compact phone navigation. It deliberately
// follows effective-role capabilities (Switch Role included), not the role
// stored on the account.
export const buildMobilePrimaryNavigation = (infoSource) => {
  const capabilities = getCommercialCapabilities(infoSource);

  if (isProviderOnlyWorkspace(infoSource)) {
    return [
      { key: "providerCenter", route: "/provider", label: elakayAutoText("h_pvc_title", "Provider Center"), icon: "center" },
      { key: "providerShop", route: "/provider/my-shop", label: elakayAutoText("h_mobile_my_shop", "My Shop"), icon: "shop" },
    ];
  }

  if (capabilities.canAccessSellerCenter) {
    return [
      { key: "sellCenter", route: "/myshop?tab=sell-center", label: elakayAutoText("h_mobile_sell_center", "Sell Center"), icon: "center" },
      { key: "myShop", route: "/myshop", label: elakayAutoText("h_mobile_my_shop", "My Shop"), icon: "shop" },
    ];
  }

  return [
    { key: "todayDeal", route: "/deal-today", label: elakayAutoText("h_mobile_today_deal", "Today's Deal"), icon: "deal" },
    { key: "yourStep", route: "/your-step", label: elakayAutoText("h_mobile_your_step", "Your Step"), icon: "step" },
  ];
};

